<template>
  <v-sheet class="password responsive-sheet">
    <h2 class="titulo">Cambiar contraseña</h2>
    <div class="inside">
      <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit" ref="form">
        <v-text-field
          v-model="password"
          label="Nueva contraseña"
          variant="solo"
          :type="show1 ? 'text' : 'password'"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append-inner="show1 = !show1"
          :rules="obligatorio"
          class="asterisco"
        >
        <template #message>
          <span v-if="!valid" class="custom-error-message">La contraseña debe tener entre 6 y 10 caracteres y al menos 1 número.</span>
        </template>
        </v-text-field>
        <v-text-field
          v-model="passwordRep"
          label="Repetir contraseña"
          variant="solo"
          :type="show2 ? 'text' : 'password'"
          :append-inner-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append-inner="show2 = !show2"
          :rules="passwordRepRules"
          class="asterisco"
        >
        <template #message>
          <span v-if="!valid" class="custom-error-message">La contraseña debe tener entre 6 y 10 caracteres y al menos 1 número.</span>
        </template>
        </v-text-field>
        <span v-if="valid && !iguales" class="custom-error-message">Las contraseñas deben coincidir.</span>
        <v-row>
          <v-col cols="12" md="6" >
            <v-btn id="boton-rojo" v-if="!(primerLogin === 'true')" block :loading="loadingSend" @click="redirigir()">
              Cancelar
            </v-btn>
          </v-col>          
          <v-col :cols="primerLogin === 'true' ? 12 : 6">
            <v-btn type="submit" block color="#bec0b5" :loading="loadingSend" :disabled="!valid || !iguales">
              Cambiar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-sheet>
  <AlertComponent
      :title="alertTitle"
      :text="alertText"
      :alertType="alertType"
      :showAlert="showAlert"
      @close="cerrarModal"
    />
</template>

<style scoped>
#boton-rojo {
  background-color: #bb3118;
  color: #ffffff;
}
.password {
  background-image: url(../../public/register-bg.jpg);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #244125;
  border-radius: 12px;
}
.responsive-sheet {
  width: 25%;
}
@media (max-width: 810px) {
  .responsive-sheet {
    width: 70%;
  }
}
.inside {
  padding: 7%;
}
.titulo {
  text-align: center;
  color: #bec0b5;
  padding-top: 2%;
}
.custom-error-message {
  color: rgb(228, 253, 226);
  font-size: 14px;
  margin-left: 4px;
}
.asterisco label::after {
    content: ' *'; 
    color: red;    
    margin-left: 4px;
    font-size: inherit; 
}
</style>

<script>
/* eslint-disable */
import "sweetalert2/dist/sweetalert2.min.css";
import AuthService from "@/api/AuthService";
import AlertComponent from "@/components/AlertComponent.vue"
import { Role } from "@/_helpers/role";

const authService = new AuthService();

export default {
  components: {
    AlertComponent
  },
  props: ['primerLogin'],
  data() {
    return {
      passwordRepRules: [
        (value) => {
          if (value?.length >= 6 && value?.length <= 10 && /\d/.test(value) && value === this.password) {
            this.iguales = true;
            return true;
          }
          if (value?.length >= 6 && value?.length <= 10 && /\d/.test(value)){
            this.iguales = false;
            return true;
          }
          this.iguales = false;
          return false;
        }
      ],
      obligatorio: [
        (value) => {
          if (value) return true;

          return "Este campo es obligatorio.";
        },
        (value) => {
          if (value?.length >= 6 && value?.length <= 10 && /\d/.test(value)) return true;
          return false;
        }
      ],
      password: "",
      passwordRep: "",
      show1: false,
      show2: false,
      loadingSend: false,
      alertTitle:'',
      alertText:'',
      alertType:'error',
      showAlert:false,
      valid: false,
      iguales:false
    };
  },
  mounted() {
    if(this.primerLogin === 'true'){
      this.alertTitle= "Bienvenido",
      this.alertType= "success",
      this.alertText= "Por favor, cambia tu contraseña para continuar.";
      this.showAlert=true;
    }
  },
  methods: {
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        this.loadingSend = true;
        const response = await authService.cambiarPassword(this.password);

        this.loadingSend = false;
        switch (response.data) {
          case "invalid":
            this.alertTitle= "Error",
            this.alertType= "error",
            this.alertText= "Ocurrió un error al actualizar la contraseña, por favor inicia sesión nuevamente con las credenciales de recuperación.";
            this.showAlert=true;
            break;
          case "same":
            this.alertTitle= "Error",
            this.alertType= "error",
            this.alertText= "La contraseña no puede ser igual a tu nombre de usuario.";
            this.showAlert=true;
            break;
          default:
            this.valid= true;
            this.alertTitle= "Contraseña actualizada";
            this.alertType= "success";
            this.alertText= "La contraseña se actualizó correctamente.";
            this.showAlert=true;
        }
      }
    },
    cerrarModal(){
      this.showAlert = false;
      if(this.valid){
        this.$router.push("/auth/login");
      }
    },
    redirigir(){
      if(this.$store.getters.getRole === Role.Auditor){
        this.$router.push('/auditoria/eleccion-os')
      }
      else{
        if(this.$store.getters.getRole === Role.AdministrativoReintegros){
          this.$router.push('/auditoria-reintegros/eleccion-paciente')
        }
        else{
          this.$router.push('/cargar-prestacion/elegibilidad')
        }
      }
    }
  }
};
</script>
